import React, { useEffect } from "react";

import QRLogInContainer from "../containers/QRLogInContainer";
import { exitPageFullscreen } from "../hooks/usePageFullscreen";

const WebSmartTVLoginPage = ({ ...props }) => {
    useEffect(() => {
        exitPageFullscreen(); // 260803 SmartTV 및 그룹 SmartTV 로그인 화면에서는 전체화면을 자동 해제한다.
    }, []);

    return (
        <QRLogInContainer {...props} />
    );
};

export default WebSmartTVLoginPage;
